import React from 'react';
import { func, string } from 'prop-types';
import styled from 'styled-components';

import { COLOR_TOKENS } from 'constants/quartz';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    color: ${COLOR_TOKENS.feedback.info.text};
`;

const Title = styled.span`
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.438rem;
`;

const Message = styled.span`
    font-size: 0.875rem;
    line-height: 1.25rem;
`;

const ReloadLink = styled.button`
    background: none;
    border: none;
    color: ${COLOR_TOKENS.text.link};
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.25rem;
    padding: 0;
    text-align: left;
    text-decoration: underline;

    &:hover {
        color: ${COLOR_TOKENS.text.linkHover};
    }
`;

const CaseEditedToast = ({ editorName, field, onReload }) => (
    <Container data-testid="case-edited-toast">
        <Title>New version published</Title>
        <Message>
            {editorName} just made changes to this case&apos;s {field}
        </Message>
        <ReloadLink data-testid="case-edited-toast-reload" onClick={onReload}>
            Reload
        </ReloadLink>
    </Container>
);

CaseEditedToast.propTypes = {
    editorName: string.isRequired,
    field: string.isRequired,
    onReload: func.isRequired,
};

export default CaseEditedToast;
